module.exports = __webpack_public_path__ + "static/media/pianoMonkey.25b89466.ogg";